<template>
  <div class="card border p-1 mb-1">
    <div v-if="isEditing">
      <SubCommentEditForm
        :initial-text="reply.comment"
        @save="saveSubEdit"
        @cancel="isEditing = false"
      />
    </div>

    <div
      v-else
      class="d-flex justify-content-between align-items-start"
    >
      <div>
        <strong>{{ fullName }}:</strong>
        <p class="mb-1">{{ reply.comment }}</p>
        <small class="text-muted">{{ formatDate(reply.createdAt) }}</small>
      </div>
      <div class="d-flex">
        <b-button
          size="sm"
          variant="outline-primary"
          class="mr-1"
          @click="isEditing = true"
        >
          Редактировать
        </b-button>
        <b-button
          size="sm"
          variant="danger"
          @click="deleteSubComment"
        >
          Удалить
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import SubCommentEditForm from './SubCommentEditForm.vue'

export default {
  name: 'SubCommentItem',
  components: { BButton, SubCommentEditForm },
  props: { reply: Object, commentId: [Number, String] },
  data() {
    return { isEditing: false }
  },
  computed: {
    fullName() {
      const u = this.reply.user
      return u ? `${u.name} ${u.surname}` : 'Неизвестный'
    },
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString('ru-RU')
    },
    async deleteSubComment() {
      try {
        await this.$http.delete(`comment/sub-comment/${this.reply.id}`)
        this.$emit('refresh')
      } catch (err) {
        console.error('Ошибка при удалении ответа:', err)
      }
    },
    async saveSubEdit(newText) {
      if (!newText.trim()) return
      try {
        await this.$http.patch(`comment/sub-comment/${this.reply.id}`, {
          comment: newText,
          isReview: false,
        })
        this.reply.comment = newText
        this.isEditing = false
      } catch (err) {
        console.error('Ошибка при сохранении ответа:', err)
      }
    },
  },
}
</script>
